import Brand from '../components/basic/general/Brand';
import Company from '../components/basic/general/Company';
import Shop from '../components/basic/general/Shop';
import Merchant from '../components/basic/general/Merchant';
import MerchantOrderType from '../components/basic/general/MerchantOrderType';
import LegalAgreement from '../components/basic/general/LegalAgreement';
import DeliveryAddress from '../components/basic/general/DeliveryAddress';
import OtherSystemAccount from '../components/basic/general/OtherSystemAccount';

import LicenseGroup from '../components/basic/license/LicenseGroup';
import License from '../components/basic/license/License';
import RoleGroup from '../components/basic/license/RoleGroup';
import Role from '../components/basic/license/Role';

import UserGroup from '../components/basic/user/UserGroup';
import User from '../components/basic/user/User';
import UserLogin from '../components/basic/user/UserLogin';

//softwareUsage
import App from '../components/basic/softwareUsage/App';
import AppVersion from '../components/basic/softwareUsage/AppVersion';
import AppDocument from '../components/basic/softwareUsage/AppDocument';

const basicRouters = [
    //basic/general
    {
        path: "/brand",
        element: <Brand />,
    },
    {
        path: "/company",
        element: <Company />,
    },
    {
        path: "/shop",
        element: <Shop />,
    },
    {
        path: "/merchant",
        element: <Merchant />,
    },
    {
        path: "/merchantOrderType",
        element: <MerchantOrderType />,
    },
    {
        path: "/legalAgreement",
        element: <LegalAgreement />,
    },
    {
        path: "/deliveryAddress",
        element: <DeliveryAddress />,
    },
    {
        path: "/otherSystemAccount",
        element: <OtherSystemAccount />,
    },

    // /basic/license
    {
        path: "/licenseGroup",
        element: <LicenseGroup />,
    },
    {
        path: "/license",
        element: <License />,
    },
    {
        path: "/roleGroup",
        element: <RoleGroup />,
    },
    {
        path: "/role",
        element: <Role />,
    },

    // /basic/user
    {
        path: "/userGroup",
        element: <UserGroup />,
    },
    {
        path: "/user",
        element: <User />,
    },
    {
        path: "/userLogin",
        element: <UserLogin />,
    },
    {
        path: "/app",
        element: <App />,
    },
    {
        path: "/appVersion",
        element: <AppVersion />,
    },
    {
        path: "/appDocument",
        element: <AppDocument />,
    },

]

export default basicRouters;